import React from "react";
import {useParams, useSearchParams} from 'react-router-dom';
import PayoutTransactionList from "../../components/event/PayoutTransactionList";
import MollieSettlementTransactionList from "../../components/event/MollieSettlementTransactionList";
import {PAYOUT_PROVIDER_MOLLIE} from "./PayoutsPage";

const PayoutTransactionsPage = () => {
    const {payoutId} = useParams();
    const [searchParams] = useSearchParams();

    // Carries over which tab the detail view was opened from, so the breakdown
    // matches the provider and "Back" returns to the same tab.
    return searchParams.get('provider') === PAYOUT_PROVIDER_MOLLIE
        ? <MollieSettlementTransactionList settlementId={payoutId}/>
        : <PayoutTransactionList payoutId={payoutId}/>
}

export default PayoutTransactionsPage;
